import React, {useEffect} from 'react'
import './index.scss'
import recordImg from 'src/images/record.png'

declare const window: any;
const Page: React.FC = () => {
	useEffect(() => {
		
		new window.WxLogin({
				id: "login_container",
				appid: "wx37b15633d5eba42d",
				scope: "snsapi_login",
				redirect_uri: window.location.origin,
				state: "001pt.com",
				style: "",
				href: "https://static.001pt.com/css/app.css"
		});
	}, [])

	return (
		<div className='login-container'>
			<div className='login-content'>
				<div className='login-content-let'>
					<div className='l-title'>001图文识别</div>
					<div className='l-line'></div>
					<div className='l-desc'>微信扫码 / 同步展示</div>
				</div>
				<div className='login-content-right'>
					<div className='login-code' id="login_container"></div>
				</div>
			</div>
			<div className='provider'>
				<p>Copyright © 2020 深圳恒合互联网络科技有限公司. All Rights Reserved</p>
				<p>粤ICP备17067845号 <img src={recordImg} alt=''/><a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402000857">粤公网安备44030402000857号</a></p>
			</div>
		</div>
	)
}

export default Page;